module.exports = __webpack_public_path__ + "static/contact-banner-622fc7d8decc75ef48ff7905cdfd0f7e.jpg";